const rankings = [
  { rank: 1, title: '刃牙VS勇次郎 最终决战', tag: '人气爆款', views: '128.6万', tagColor: 'bg-primary-500' },
  { rank: 2, title: '地下竞技场 死亡囚犯篇', tag: '经典必读', views: '96.3万', tagColor: 'bg-accent-500' },
  { rank: 3, title: '中国大擂台赛 完整收录', tag: '热度飙升', views: '87.5万', tagColor: 'bg-primary-500' },
  { rank: 4, title: '范马刃牙 正传全集', tag: '长期霸榜', views: '82.1万', tagColor: 'bg-secondary-500' },
  { rank: 5, title: '刃牙道 最新连载', tag: '每周更新', views: '75.8万', tagColor: 'bg-accent-500' },
  { rank: 6, title: '烈海王异世界 番外', tag: '口碑佳作', views: '68.4万', tagColor: 'bg-secondary-500' },
  { rank: 7, title: '花山薰外传 拳王之路', tag: '黑马逆袭', views: '61.2万', tagColor: 'bg-primary-500' },
];

export default function RankingSection() {
  return (
    <section id="ranking" className="py-14 md:py-20 bg-background-50">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <h2 className="text-2xl md:text-3xl font-heading text-foreground-950 text-center mb-3">
          人气排行
        </h2>
        <p className="text-sm md:text-base text-foreground-500 text-center mb-10 md:mb-14 max-w-xl mx-auto">
          刃牙漫画在线观看最受欢迎章节排行榜
        </p>

        <div className="max-w-3xl mx-auto">
          {rankings.map((item, idx) => (
            <div
              key={item.rank}
              className={`flex items-center gap-4 py-4 px-4 md:px-6 rounded-xl transition-colors hover:bg-background-100 cursor-pointer ${
                idx < rankings.length - 1 ? 'border-b border-background-200/70' : ''
              }`}
            >
              <div className={`flex-shrink-0 w-8 h-8 md:w-10 md:h-10 flex items-center justify-center rounded-lg font-heading text-base md:text-lg ${
                item.rank === 1 ? 'bg-primary-500 text-white' :
                item.rank === 2 ? 'bg-primary-100 text-primary-600' :
                item.rank === 3 ? 'bg-accent-100 text-accent-600' :
                'bg-background-200 text-foreground-500'
              }`}>
                {item.rank}
              </div>
              <div className="flex-1 min-w-0">
                <div className="flex items-center gap-2 flex-wrap">
                  <h3 className="text-sm md:text-base font-heading text-foreground-950 truncate">{item.title}</h3>
                  <span className={`flex-shrink-0 px-2 py-0.5 rounded-full ${item.tagColor} text-white text-xs font-medium whitespace-nowrap`}>
                    {item.tag}
                  </span>
                </div>
              </div>
              <div className="flex-shrink-0 text-xs md:text-sm text-foreground-400 whitespace-nowrap">
                <i className="ri-eye-line mr-1"></i>{item.views}
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}